import cn from "classnames"
import Image from "components/Image"
import richText from "utilities/richText"
import getImageDimensions from "utilities/getImageDimensions"

export default function InlineImage({ blok }) {
  const widthClass = {
    full: "md:w-full",
    half: "md:w-1/2",
    third: "md:w-1/3",
    quarter: "md:w-1/4",
  }[blok.image_width]

  const alignmentClass = {
    left: "md:float-left md:pl-0 md:pr-6",
    right: "md:float-right md:pr-0 md:pl-6",
    center: "mx-auto block",
  }[blok.image_alignment]

  const imageWidth = Number(getImageDimensions("width", blok?.image?.filename))
  const imageHeight = Number(getImageDimensions("height", blok?.image?.filename))

  return (
    <div className={cn("py-4 px-0", widthClass, alignmentClass, { "inline-block": blok.image_alignment !== "center" })}>
      <Image
        alt={blok.image.alt}
        src={blok.image.filename}
        height={imageHeight}
        width={imageWidth}
        className="h-auto w-full object-cover"
      />
      {blok.caption && <div className="prose-p:pb-1 pt-2 text-s1">{richText(blok.caption)}</div>}
    </div>
  )
}
